/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import Loader from "react-loader";
import { Paper, Typography, Tabs, Tab } from "@material-ui/core";
import moment from "moment";

// components
import MainLayout from "../../components/hoc/MainLayout";
import TabPanel from "../../components/TabPanel";
import RidersTable from "../../components/RidersTable";
import StoresTable from "../../components/StoresTable";
import DateFilter from "../../components/DateFilter";
import Export from "../../components/reports/ExportRidersStores";

// helpers
import { apiGet } from "../../helpers/api";

function AvgAtTheDoorTime(props) {
  const [value, setValue] = useState(0);
  const [ridersData, setRidersData] = useState(null);
  const [storesData, setStoresData] = useState(null);
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(new Date());
  const [orderType, setOrderType] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchData = useCallback(async () => {
    setRidersData(null);
    setStoresData(null);

    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(endDate).format("YYYY-MM-DD");

    // get data from api
    try {
      let url = `/reports/average_at_the_door_time?date_from=${start}&date_to=${end}`;
      if (orderType !== "") {
        url += `&type=${orderType}`;
      }
      const response = await apiGet(url);
      setRidersData(response.data.riders);
      setStoresData(response.data.stores);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  }, [startDate, endDate, orderType]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Loader loaded={ridersData !== null && storesData !== null}>
      <Typography variant="h5" gutterBottom>
        Average At The Door Time
      </Typography>

      <DateFilter
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        filterAction={fetchData}
        orderType={orderType}
        orderTypeChangeHandler={(e) => {
          setOrderType(e.target.value);
        }}
        exportComponent={{
          component: Export,
          isDuration: true,
          storesData,
          ridersData,
          filename: "average-at-the-door-delivery-time",
          disabled: ridersData?.length === 0 && storesData?.length === 0,
        }}
      />

      <Paper square>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="disabled tabs example"
        >
          <Tab label="Riders" />
          <Tab label="Stores" />
        </Tabs>
        <TabPanel value={value} index={0}>
          <RidersTable data={ridersData} isDuration></RidersTable>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <StoresTable data={storesData} isDuration></StoresTable>
        </TabPanel>
      </Paper>
    </Loader>
  );
}

export default MainLayout(AvgAtTheDoorTime);
